<template>
  <div class="user-status">
    <div class="left">
      <div>
        <a href="/advisor-dashboard/#settings">
          <i
            class="fa fa-cog"
            title="Settings"
          />
        </a>
      </div>

      <span class="line">|</span>
      <span class="name">Signed in as {{ name }}</span>
    </div>

    <form
      action="/accounts/logout/"
      method="post"
    >
      <input
        type="hidden"
        name="csrfmiddlewaretoken"
        :value="csrfToken"
      >
      <button
        type="submit"
        class="logout-button"
      >
        <i
          class="fa fa-sign-out-alt"
          title="Logout"
        />
      </button>
    </form>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['advisor'],
  data() {
    return { csrfToken: '' };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    name() {
      return this.advisor?.name;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]')?.value;
  },
  updated() {},
  methods: {},
};
</script>


<style scoped>
  .user-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .left {
    display: flex;
    align-items: center;
    gap: 0.25em;
  }

  .line {
    font-size: 18px;
    color: #808080;
  }

  .name {
    font-size: 14px;
  }

  a {
    color: inherit;
    /* border: 1px dashed blue; */
  }

  a:hover {
    color: #3a66ac;
  }

  .logout-button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  .logout-button:hover {
    color: #3a66ac;
  }
</style>
